import React from 'react';
import {
  Avatar,
  Box,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  InputLabel
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { numberFormat } from '../../utils/nunberFormat';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ROWS_PER_PAGE } from '../../config-global';
import { useCustomerControllers } from './controller';
import Facebook from '../../assets/images/logo/facebook.svg';
import Google from '../../assets/images/logo/google.svg';
import Phone from '../../assets/images/logo/phone.svg';
import Apple from '../../assets/images/logo/apple.svg';
import Email from '../../assets/images/logo/email.svg'
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import { CustomerProfileModel } from '../../models/customerProfile';
import StatusChip from '../../components/StatusChip';
import CustomerForm from './Form';
import TabPanelActiveComponent from './components';
import { IMAGE_CUSTOMER } from '../../lib/endpoints/customer';
import StatusComponents from './components/status';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';

const CustomerView = () => {
  const { t } = useTranslation('global');
  const controllers = useCustomerControllers();
  const tableHeaders: string[] = [t("customer_page.No"), t("customer_page.Profile"), t("customer_page.Full Name"), t("customer_page.Email"), t("customer_page.Phone"), t("customer_page.Register_via"), t("customer_page.Status"), ""]

  return (
    <Box>
      {controllers.openForm ? (
        <CustomerForm
          onClose={controllers.handleCloseFormCustomer}
          selectedProfile={controllers.selectedProfile}
          onSelectProfile={controllers.selectProfile}
          onFetchCustomer={controllers.handleFetchData}
        />
      ) :
        controllers.loadingData ?
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingAnimatedIcon />
          </Box> :
          <>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t('User management')}</Typography>
                <TextField
                  fullWidth
                  sx={{ maxWidth: 250 }}
                  placeholder={t('customer_page.Search') || ""}
                  onKeyDown={(e: any) => {
                    if (e.key === "Enter") {
                      controllers.handleFetchFilterCustomer()
                    }
                  }}
                  inputRef={controllers.search}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton onClick={() => controllers.handleFetchFilterCustomer()}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
                <Box>
                  <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                    <InputLabel id="select">{t("customer_page.Search by")}</InputLabel>
                    <Select
                      value={controllers.selectedOption}
                      onChange={controllers.handleSelectedOption}
                      label='Search by'
                      labelId='select'
                      sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                    >
                      <MenuItem value={'fullName'}>{t("customer_page.Full Name")}</MenuItem>
                      <MenuItem value={'email'}>{t("customer_page.Email")}</MenuItem>
                      <MenuItem value={'phone'}>{t("customer_page.Phone")}</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <TextField
                  type="date"
                  fullWidth
                  // inputRef={controller.startDate}
                  sx={{
                    maxWidth: 150,
                  }}
                  size="small"
                  label={t("customer_page.Start Date")}
                  value={controllers.registerDate}
                  onChange={(e) => controllers.handleSelectRegisterDate(e)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      borderRadius: '5px',
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="date"
                  fullWidth
                  // inputRef={controller.startDate}
                  sx={{
                    maxWidth: 150,
                  }}
                  size="small"
                  label={t("customer_page.End Date")}
                  value={controllers.endDate}
                  onChange={(e) => controllers.setEndDate(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      borderRadius: '5px',
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </Box>
            <Box sx={{ mt: 2, display: 'flex' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <StatusComponents
                    BgColor='#C4EAFF'
                    FontColor='#005249'
                    title={t("customer_page.All Customer")}
                    loading={controllers.loadingCount}
                    countNumber={controllers.allCustomer}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <StatusComponents
                    BgColor='#C8FACD'
                    FontColor='#005249'
                    title={t("customer_page.Active Customer")}
                    loading={controllers.loadingCount}
                    countNumber={controllers.isActiveCustomer}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <StatusComponents
                    BgColor='#FFACB6'
                    FontColor='#005249'
                    title={t("customer_page.InActive Customer")}
                    loading={controllers.loadingCount}
                    countNumber={controllers.isBannedCustomer}
                  />
                </Grid>
              </Grid>
            </Box>
            {/* <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'end' }}>
            <Button
              variant='contained'
              sx={{ background: '#11A2F1', textTransform: 'none', borderRadius: '8px' }}
            >
              <LogoutIcon />
              &nbsp;&nbsp;
              export to csv
            </Button>
          </Box> */}

            <Box
              sx={{ mb: 1, mt: 2, background: '#F4F6F8', borderColor: 'divider' }}
            >
              <TabPanelActiveComponent value={controllers.tabStatus} onChange={controllers.handleSetTabStatus} />
            </Box>
            <Box>
              {
                controllers.loadingSearchData ? <LinearProgress /> :
                  <>
                    <TableContainer>
                      <Table>
                        <TableHead sx={{ background: '#F4F6F8' }}>
                          <TableRow>
                            {
                              tableHeaders?.map((item, index) => <TableCell key={index} sx={{ borderBottom: "none" }}>{item}</TableCell>)
                            }
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {controllers.rows?.map((row: CustomerProfileModel, index: number) => {
                            const {
                              customer,
                              profile
                            } = row;
                            const isActive: boolean = !customer?.isBan;
                            const getIconSource = () => {
                              return (
                                customer?.phone ? Phone :
                                  customer?.googleId ? Google :
                                    customer?.facebookId ? Facebook :
                                      customer?.appleId ? Apple :
                                        customer?.email ? Email :
                                          undefined
                              );
                            };
                            return (
                              <TableRow key={index}>
                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                  {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controllers.currentPage - 1))}
                                </TableCell>
                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                  <Avatar
                                    alt=""
                                    src={IMAGE_CUSTOMER + profile?.image?.url}
                                    style={{
                                      cursor: 'pointer',
                                      objectFit: 'contain',
                                      borderRadius: 180,
                                      width: 50,
                                      height: 50,
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {profile?.fullName}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {customer?.email }
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {customer?.phone }
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  <img
                                    src={getIconSource()}
                                    style={{ width: 25, height: 25 }}
                                    alt=""
                                  />
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  <StatusChip status={isActive} />
                                </TableCell>
                                <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                  <IconButton
                                    size="large"
                                    color="inherit"
                                    onClick={(e: any) => controllers.handleOpenMenu(e, customer?.id && profile?.id)}
                                  >
                                    <MoreHorizIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Divider sx={{ mt: 1, mb: 1 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                      <Pagination
                        color='primary'
                        count={controllers.countPagination}
                        page={controllers.currentPage}
                        onChange={controllers.handleChangePage}
                      />
                    </Box>
                  </>
              }


              {
                controllers.loadingDataMore
                &&
                <Box mb={2} mt={2}>
                  <LinearProgress />
                </Box>
              }
            </Box>
            <Popover
              open={Boolean(controllers.openMenu)}
              anchorEl={controllers.openMenu}
              onClose={controllers.handleCloseMenu}
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{
                sx: {
                  p: 1,
                  width: 140,
                  '& .MuiMenuItem-root': {
                    px: 1,
                    typography: 'body2',
                    borderRadius: 0.75,
                  },
                },
              }}
            >
              <MenuItem onClick={() => controllers.handleOpenFormCustomer()}>
                <InfoIcon />
                &nbsp;&nbsp;
                {t('See Detail')}
              </MenuItem>
            </Popover>
          </>
      }
    </Box>
  );
};
export default CustomerView;
